import { createAsyncReducer } from "@telstra-connect/standard-actions/reducers";
import {
    ILoadIncidentsListErrorAction,
    ILoadIncidentsListResetAction,
    ILoadIncidentsListStartAction,
    ILoadIncidentsListSuccessAction,
    IUpdateSelectedColumnsAction,
} from "../actions/track-incidents-list/types";
import { ITicketsState } from "../state";
import { initialState } from "./initial-state";

type ILoadProductSuccessConsolidated =
    | ILoadIncidentsListSuccessAction
    | IUpdateSelectedColumnsAction;

export type LoadIncidentsListAction =
    | ILoadIncidentsListStartAction
    | ILoadProductSuccessConsolidated
    | ILoadIncidentsListErrorAction
    | ILoadIncidentsListResetAction;

const init = (
    state: ITicketsState,
    action: LoadIncidentsListAction
): ITicketsState => {
    const startAction = action as ILoadIncidentsListStartAction;
    const { error, ...rest } = state.trackIncidentsList;
    return {
        ...state,
        trackIncidentsList: {
            ...rest,
            incidentList: null,
            status: action.status,
            tableConfig:
                startAction.data?.tableConfig ??
                state.trackIncidentsList.tableConfig,
            selectedFilters:
                startAction.data?.selectedFilters ??
                state.trackIncidentsList.selectedFilters,
            searchText:
                typeof startAction.data?.searchText === "string"
                    ? startAction.data.searchText
                    : state.trackIncidentsList.searchText,
            sortParam:
                startAction.data?.sortParam ??
                state.trackIncidentsList.sortParam,
            selectedColumns:
                startAction.data?.selectedColumns ||
                state.trackIncidentsList.selectedColumns,
        },
    };
};

const success = (
    state: ITicketsState,
    action: LoadIncidentsListAction
): ITicketsState => {

    // Separate sessionId from incidentListAPiResponse
    const { sessionId, ...incidentList } = (action as ILoadIncidentsListSuccessAction).data
        ?.incidentList || null;

    return {
        ...state,
        trackIncidentsList: {
            ...state.trackIncidentsList,
            status: (action as ILoadProductSuccessConsolidated).updateState
                ? action.status
                : state.trackIncidentsList.status,
            incidentList: incidentList || state.trackIncidentsList.incidentList,
            sessionId: sessionId || state.trackIncidentsList.sessionId,
            selectedColumns:
                (action as IUpdateSelectedColumnsAction).data
                    ?.selectedColumns ||
                state.trackIncidentsList.selectedColumns,
            ...((action as ILoadProductSuccessConsolidated).updateState && {
                hideFilterAction: false,
            }),
        },
    };
};

const failure = (
    state: ITicketsState,
    action: LoadIncidentsListAction
): ITicketsState => {
    return {
        ...state,
        trackIncidentsList: {
            ...state.trackIncidentsList,
            status: (action as ILoadIncidentsListErrorAction).status,
            error: (action as ILoadIncidentsListErrorAction).error,
        },
    };
};

const reset = (
    state: ITicketsState,
    action: LoadIncidentsListAction
): ITicketsState => {
    return {
        ...state,
        trackIncidentsList: {
            ...state.trackIncidentsList,
            status: (action as ILoadIncidentsListErrorAction).status,
            incidentList: null,
            tableConfig: {
                currentPage: 1,
                pageSize: 25
            },
            sessionId: null,
        },
    };
};

export const loadIncidentsListReducer = createAsyncReducer(
    initialState,
    init,
    success,
    failure,
    reset
);

